import { render, staticRenderFns } from "./ColorDisplay.vue?vue&type=template&id=d48400f2&"
import script from "./ColorDisplay.vue?vue&type=script&lang=js&"
export * from "./ColorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports